/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import { updateIntl } from 'react-intl-redux';
import {
  MenuItem,
  NavDropdown,
} from 'react-bootstrap';
import i18n from '../../../../i18n';
import imgCn from './images/cn.svg';
import imgEn from './images/gb.svg';
import styles from './styles/main.scss';


const propTypes = {
  locale: React.PropTypes.string.isRequired,
  updateIntl: React.PropTypes.func.isRequired,
};

class LangSwitcher extends React.Component {

  static getFlagIcon(languageId) {
    switch (languageId) {
      case 'zh': return (<span><img src={imgCn} alt="" />{' 简体中文'}</span>);
      case 'en': return (<span><img src={imgEn} alt="" />{' English'}</span>);
      default: return (<span><img src={imgCn} alt="" />{' 简体中文'}</span>);
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      language: props.locale || 'zh',
    };
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { locale } = nextProps;
    if (locale !== this.props.locale) {
      this.setState({ language: locale });
    }
  }

  handleChangeLanguage(languageId) {
    this.setState({
      language: languageId,
    });
    this.props.updateIntl({
      locale: languageId,
      messages: i18n[languageId],
    });
    localStorage.setItem('language', languageId);
    $('html, body').css({
      overflow: 'auto',
      height: 'auto',
    });
  }

  render() {
    const { language } = this.state;
    const title = LangSwitcher.getFlagIcon(language);
    return (
      <NavDropdown
        id="lang-switcher"
        noCaret
        pullRight
        title={title}
        key={1}
      >
        <MenuItem eventKey="1" onClick={() => this.handleChangeLanguage('zh')}>
          {LangSwitcher.getFlagIcon('zh')}
        </MenuItem>
        <MenuItem eventKey="2" onClick={() => this.handleChangeLanguage('en')}>
          {LangSwitcher.getFlagIcon('en')}
        </MenuItem>
      </NavDropdown>
    );
  }
}

LangSwitcher.propTypes = propTypes;

const mapStateToProps = state => ({
  locale: state.intl.locale,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  updateIntl,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LangSwitcher, styles));




// WEBPACK FOOTER //
// ./src/containers/App/coms/LangSwitcher/index.jsx